module.exports = __webpack_public_path__ + "static/9-e41283113e411855668e5ff94ce053ff.png";